import { render } from "./StrokedPlusIcon.vue?vue&type=template&id=3605f142"
import script from "./StrokedPlusIcon.vue?vue&type=script&lang=js"
export * from "./StrokedPlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__